import styled from 'styled-components'

export const DatWrapper = styled.div`
  color: #eee;
  width: 280px;
`
